export default __webpack_public_path__ + "static/media/white-logo-with-word.0e359908.svg";